import { NotificationAction, NotificationMessage } from './types';

export const addNotification = (message: NotificationMessage) =>
  ({
    type: NotificationAction.ADD_NOTIFICATION,
    payload: message,
  } as const);

export const removeNotification = (id: string) =>
  ({
    type: NotificationAction.REMOVE_NOTIFICATION,
    payload: id,
  } as const);

export const updateNotification = (message: NotificationMessage) =>
  ({
    type: NotificationAction.UPDATE_NOTIFICATION,
    payload: message,
  } as const);
